<template>
    <div>
        <div class="row align-items-center">
            <form-field ref="descricao" v-model="gruest.descricao" type="text" col="6" :metadata="metadata.gruest.descricao" 
                case="normal" name="descricao" :v-errors="errors" v-validate="metadata.gruest.descricao.validator"></form-field>
            <div class="col-md-4 col-6">
                <v-button label="Salvar" :nb-btdef="true" @click="handleSave"></v-button>
                <v-button label="Cancelar" @click="closeForm"></v-button>
            </div>
        </div>
    </div>
</template>

<script>

import { SysVars } from '../main'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'

export default {
    props: {
        index: '',
        pai: {Object},
        crud: '',
    },

    data() {
        return {
            crudText: '',
            gruest: {...this.$store.getters.getEntities.gruest},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
        }
    },

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        }

    },

    methods: {
        closeForm () {
            this.$emit('closeform', this.gruest.codgruest)
        },

        handleSave () {
            //BOTAO SALVAR
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })
        },

        async loadData () {
            //carrega o registro para alteracao ou visualizacao
            await this.$store.dispatch('loadGruest', { id: this.index } )
            if (this.$store.getters.getGruest) {
                this.gruest = {...this.$store.getters.getGruest}
            }  
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        async apiPost () {
            //efetua a gravacao

            var modulo = 'cg/gruest/'
            var sendData = {}

            if (this.pai)
              this.gruest.codgruestpai = this.pai.codgruest

            sendData = { gruest: this.gruest }

            let metodo = 'post'
            let update = false
            if (this.crud != SysVars.crudI) {
                update = true
            }
            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.closeForm()
            }
        },
        
    },

    components: {

    },

    beforeCreate () {

    },

    created () {
        this.crudText = this.$crudText(this.crud)

        if (this.crud == SysVars.crudI) {
        } else {
            this.loadData()  
        }
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
            this.$refs.descricao.focus()
        })
    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/gruest-form.vue